import classNames from "classnames"
import React from "react"

import { getThemeColor } from "./utils"
import { isTablet } from "../../../../utils/V2/screen"
import Typography from "../../../elements/V2/Typography"

type IconCellProps = {
  icon: React.ReactNode
  text?: string
  theme: "light" | "dark"
}

const IconCell = ({ icon, text, theme }: IconCellProps) => (
  <div
    className={classNames("flex items-center", text && "w-full justify-start")}
  >
    {icon}
    {text && (
      <Typography
        font="grotesk"
        weight="book"
        color={getThemeColor(theme)}
        size={isTablet() ? "subscript-sm" : "body-md"}
        text={text}
        className="pl-16 text-start sm:pl-[2px] md:pl-10"
      />
    )}
  </div>
)

export default IconCell
